import { Button, Card, Container, Divider, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { downloadV2VSheet, getMemberV2VSheetData } from "src/api/commonapi";
import { Routes } from "../constant/api_url";
import Page from "src/components/Page";

export default function MemberV2VSheet() {
  const navigate = useNavigate();
  let { member_id } = useParams();
  const [v2vSheetData, setv2vSheetData] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getMemberV2VSheetData(member_id);
      setv2vSheetData(res.data);
    };

    fetchData();
  }, [member_id]);

  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const img = new Image();
    const actualImg = `${Routes.API_HOSTNAME}images/member/${v2vSheetData.photo}`;
    const fallbackImg = `${Routes.API_HOSTNAME}images/member/users.jpg`;

    img.src = actualImg;

    img.onload = () => setImageUrl(actualImg); // if image loads successfully
    img.onerror = () => setImageUrl(fallbackImg); // if image doesn't exist
  }, [v2vSheetData.photo]);

  const downloadV2VSheetData = async (member_id) => {
    try {
      setDownloadingId(member_id);
      const resp = await downloadV2VSheet(member_id);

      if (resp.status === 1 && resp.filename) {
        const fileUrl = `${Routes.API_HOSTNAME}memberv2vsheet-pdf/${resp.filename}`; // Update with your actual API URL
        // Fetch the file as a blob
        const response = await fetch(fileUrl, { method: "GET" });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        // Create an invisible <a> element to trigger download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", resp.filename); // Force download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        console.error("Error: PDF not generated");
      }
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setDownloadingId(null); // Re-enable the button
    }
  };

  const splitTablesBalanced = (services) => {
    const fullWidth = [];
    const leftColumn = [];
    const rightColumn = [];

    // ✅ Filter out services with no name or empty items
    const validServices = services.filter(
      (s) => s.name?.trim() && Array.isArray(s.items) && s.items.length > 0
    );

    if (validServices.length === 0) {
      return { fullWidth, leftColumn, rightColumn };
    }

    if (validServices.length === 1) {
      fullWidth.push(validServices[0]);
      return { fullWidth, leftColumn, rightColumn };
    }

    const half = Math.ceil(validServices.length / 2);
    leftColumn.push(...validServices.slice(0, half));
    rightColumn.push(...validServices.slice(half));

    return { fullWidth, leftColumn, rightColumn };
  };

  const { fullWidth, leftColumn, rightColumn } = splitTablesBalanced(v2vSheetData.service || []);

  const renderTable = (service) => (
    <table
      className="content-table"
      style={{ width: "100%", marginBottom: "15px", borderCollapse: "collapse" }}
    >
      <thead>
        <tr>
          <th></th>
          <th>{service.name}</th>
        </tr>
      </thead>
      <tbody>
        {service.items.map((item, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <Page title="Member's V2V Sheet | Local Vocal Business Group">
      <Container maxWidth="md">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            Member's V2V Sheet
          </Typography>
          <div>
            <Button
              variant="outlined"
              style={{ marginRight: "10px" }}
              onClick={() => downloadV2VSheetData(member_id)}
              disabled={downloadingId === member_id}
            >
              {downloadingId === member_id ? "Downloading..." : "Download PDF"}
            </Button>

            <Button variant="contained" onClick={() => navigate("/members-v2v-sheet-report")}>
              Back
            </Button>
          </div>
        </Stack>

        <Card sx={{ p: 3, mb: 3 }}>
          <style>
            {`
              th,
              td {
                padding: 6px;
                text-align: left;
                font-size: 14px;
              }

              th {
                background: #1c4766;
                color: #fff;
              }

              .firstsec td, th, .content-table td, th {
                border: 1px solid #ddd;
              }

              .section {
                margin-top: 20px;
              }

              .section-header {
                background-color: #1c4766;
                color: #fff;
                padding: 5px 10px;
                font-weight: bold;
                border-radius: 5px;
                display: inline-block;
                margin-bottom: 10px;
                font-size: 16px;
                text-transform: uppercase;
              }

              ul li{
                font-size: 16px;
              }

              .content-table {
                margin-top: 20px;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 0 0 1px #ddd;
              }
              .content-table th, .content-table td {
                padding: 8px;
                text-align: left;
              }
              `}
          </style>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td style={{ width: "65%", verticalAlign: "top" }}>
                  <div
                    style={{
                      background: "#f3f3f3",
                      padding: "15px",
                      borderRadius: "8px",
                      borderLeft: "5px solid #1c4766"
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#1c4766",
                        color: "#fff",
                        padding: "5px 10px",
                        fontWeight: "bold",
                        borderRadius: "5px",
                        display: "inline-block",
                        marginBottom: "10px"
                      }}
                    >
                      INTRODUCTION
                    </div>
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                      className="firstsec"
                    >
                      <tbody style={{ display: "table-row-group" }}>
                        <tr>
                          <td>
                            <strong>Name</strong>
                          </td>
                          <td>{v2vSheetData.m_name}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Mobile Number</strong>
                          </td>
                          <td>{v2vSheetData.mobile_no}</td>
                        </tr>
                        {v2vSheetData.m_email_id != null && v2vSheetData.m_email_id != "" && (
                          <tr>
                            <td>
                              <strong>Email</strong>
                            </td>
                            <td>{v2vSheetData.m_email_id}</td>
                          </tr>
                        )}
                        {v2vSheetData.blood_group != null && v2vSheetData.blood_group != "" && (
                          <tr>
                            <td>
                              <strong>Blood Group</strong>
                            </td>
                            <td>{v2vSheetData.blood_group}</td>
                          </tr>
                        )}
                        {v2vSheetData.dob != null && v2vSheetData.dob != "" && (
                          <tr>
                            <td>
                              <strong>Birth Date</strong>
                            </td>
                            <td>{v2vSheetData.dob}</td>
                          </tr>
                        )}
                        <tr>
                          <td>
                            <strong>Company Name</strong>
                          </td>
                          <td>{v2vSheetData.business_name}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Category</strong>
                          </td>
                          <td>{v2vSheetData.business_category}</td>
                        </tr>
                        {v2vSheetData.website_url != null && v2vSheetData.website_url != "" && (
                          <tr>
                            <td>
                              <strong>Website</strong>
                            </td>
                            <td>
                              <a
                                href={
                                  v2vSheetData.website_url.startsWith("http")
                                    ? v2vSheetData.website_url
                                    : `https://${v2vSheetData.website_url}`
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                {v2vSheetData.website_url}
                              </a>
                            </td>
                          </tr>
                        )}
                        {v2vSheetData.business_since != null &&
                          v2vSheetData.business_since != "" &&
                          v2vSheetData.BusinessExperience && (
                            <tr>
                              <td>
                                <strong>Business Since</strong>
                              </td>
                              <td>{v2vSheetData.BusinessExperience}</td>
                            </tr>
                          )}
                        {v2vSheetData.b_address != null && v2vSheetData.b_address != "" && (
                          <tr>
                            <td>
                              <strong>Business Address</strong>
                            </td>
                            <td>{v2vSheetData.b_address}</td>
                          </tr>
                        )}
                        {v2vSheetData.village != null && v2vSheetData.village != "" && (
                          <tr>
                            <td>
                              <strong>Village</strong>
                            </td>
                            <td>{v2vSheetData.village}</td>
                          </tr>
                        )}
                        {v2vSheetData.taluka != null && v2vSheetData.taluka != "" && (
                          <tr>
                            <td>
                              <strong>Taluka</strong>
                            </td>
                            <td>{v2vSheetData.taluka}</td>
                          </tr>
                        )}
                        {v2vSheetData.district != null && v2vSheetData.district != "" && (
                          <tr>
                            <td>
                              <strong>District</strong>
                            </td>
                            <td>{v2vSheetData.district}</td>
                          </tr>
                        )}
                        {v2vSheetData.education != null && v2vSheetData.education != "" && (
                          <tr>
                            <td>
                              <strong>Education</strong>
                            </td>
                            <td>{v2vSheetData.education}</td>
                          </tr>
                        )}
                        {v2vSheetData.marital_status != null &&
                          v2vSheetData.marital_status != "" && (
                            <tr>
                              <td>
                                <strong>Marital Status</strong>
                              </td>
                              <td>{v2vSheetData.marital_status == 0 ? "Unmarried" : "Married"}</td>
                            </tr>
                          )}
                        {/* <tr>
                          <td>
                            <strong>In LVB Since</strong>
                          </td>
                          <td>{v2vSheetData.joinLVB}</td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </td>
                <td style={{ width: "35%", textAlign: "center" }}>
                  <div style={{ position: "relative", width: 230, height: 230, margin: "0 auto" }}>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        backgroundImage: `url(${imageUrl})`,
                        // backgroundImage: `url(${Routes.API_HOSTNAME}images/member/${v2vSheetData.photo || 'users.jpg'})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        border: "3px solid #1c4766"
                      }}
                    ></div>
                    {v2vSheetData.m_verify_status == "1" && (
                      <img
                        src={`${Routes.API_HOSTNAME}images/verified_green.png`}
                        alt="badge"
                        style={{ position: "absolute", top: 23, right: -11, width: 60, height: 60 }}
                      />
                    )}
                    {v2vSheetData.m_verify_status == "2" && (
                      <img
                        src={`${Routes.API_HOSTNAME}images/verified_blue.png`}
                        alt="badge"
                        style={{ position: "absolute", top: 23, right: -11, width: 60, height: 60 }}
                      />
                    )}
                  </div>
                  {v2vSheetData.business_logo !== null && v2vSheetData.business_logo !== "" && (
                    <div
                      style={{
                        margin: "50px auto 0 auto",
                        height: "230px",
                        width: "230px",
                        border: "2px solid #1c4766",
                        borderRadius: "5px",
                        padding: "5px"
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          borderRadius: "5px",
                          backgroundImage: `url(${Routes.API_HOSTNAME}images/member/${v2vSheetData.business_logo})`,
                          backgroundSize: "contain",
                          backgroundPosition: "center center",
                          backgroundRepeat: "no-repeat"
                        }}
                      ></div>
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  {v2vSheetData.pin_hide_show === 0 && v2vSheetData.member_pins?.length ? (
                    <Grid container spacing={2} alignItems="center" marginTop="10px">
                      <Grid item sm={12}>
                        <div className="section-header">ACHIEVEMENT PINS :</div>
                      </Grid>
                      <Grid
                        item
                        sm={12}
                        style={{ padding: "0", display: "flex", flexWrap: "wrap" }}
                      >
                        {v2vSheetData.member_pins.map((pin, index) => (
                          <img
                            src={`${Routes.API_HOSTNAME}pin-image/${pin.image}`}
                            alt={pin.name}
                            style={{ height: "80px", width: "auto", marginRight: "10px" }}
                          />
                        ))}
                      </Grid>
                    </Grid>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            {v2vSheetData.skills &&
              Array.isArray(v2vSheetData.skills) &&
              v2vSheetData.skills.filter((skill) => skill != null && skill !== "").length > 0 && (
                <tr>
                  <td style={{ width: "100%", verticalAlign: "top" }}>
                    <div className="section">
                      <div className="section-header">SKILL :</div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            {/* Left Column: First 5 Skills */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.skills
                                  .filter((skill) => skill != null && skill !== "")
                                  .slice(0, 5)
                                  .map((skill, index) => (
                                    <li key={index} style={{ display: "list-item" }}>
                                      {skill}
                                    </li>
                                  ))}
                              </ul>
                            </td>

                            {/* Right Column: Remaining Skills */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.skills
                                  .filter((skill) => skill != null && skill !== "")
                                  .slice(5)
                                  .map((skill, index) => (
                                    <li key={index + 5} style={{ display: "list-item" }}>
                                      {skill}
                                    </li>
                                  ))}
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}

            {/* <tr>
              <td style={{ width: "100%", verticalAlign: "top" }}>
                <div className="section">
                  <div className="section-header">ACHIEVEMENT :</div>
                  {Array.isArray(v2vSheetData.achievements) &&
                  v2vSheetData.achievements.length > 0 ? (
                    <ul
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        listStyleType: "circle",
                        paddingLeft: "30px",
                        rowGap: "8px",
                        columnGap: "30px"
                      }}
                    >
                      {v2vSheetData.achievements.map((achieve, index) => (
                        <li key={index} style={{ display: "list-item" }}>
                          {achieve}
                        </li>
                      ))}
                    </ul>
                  ) : typeof v2vSheetData.achievements === "string" &&
                    v2vSheetData.achievements.trim() !== "" ? (
                    <ul style={{ listStyleType: "circle", paddingLeft: "30px" }}>
                      <li style={{ display: "list-item" }}>{v2vSheetData.achievements}</li>
                    </ul>
                  ) : (
                    <Typography variant="body2">No Achievement available</Typography>
                  )}
                </div>
              </td>
            </tr> */}
            {(Array.isArray(v2vSheetData.achievements) &&
              v2vSheetData.achievements.filter((a) => a != null && a !== "").length > 0) ||
            (typeof v2vSheetData.achievements === "string" &&
              v2vSheetData.achievements.trim() !== "") ? (
              <tr>
                <td style={{ width: "100%", verticalAlign: "top" }}>
                  <div className="section">
                    <div className="section-header">ACHIEVEMENT :</div>

                    {/* Case: Array of achievements */}
                    {Array.isArray(v2vSheetData.achievements) &&
                    v2vSheetData.achievements.filter((a) => a != null && a !== "").length > 0 ? (
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            {/* Left Column: First 5 Achievements */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.achievements
                                  .filter(
                                    (achievement) => achievement != null && achievement !== ""
                                  )
                                  .slice(0, 5)
                                  .map((achieve, index) => (
                                    <li key={index} style={{ display: "list-item" }}>
                                      {achieve}
                                    </li>
                                  ))}
                              </ul>
                            </td>

                            {/* Right Column: Remaining Achievements */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.achievements
                                  .filter(
                                    (achievement) => achievement != null && achievement !== ""
                                  )
                                  .slice(5)
                                  .map((achieve, index) => (
                                    <li key={index + 5} style={{ display: "list-item" }}>
                                      {achieve}
                                    </li>
                                  ))}
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : typeof v2vSheetData.achievements === "string" &&
                      v2vSheetData.achievements.trim() !== "" ? (
                      // Case: Single string achievement
                      <ul style={{ listStyleType: "circle", paddingLeft: "30px", margin: 0 }}>
                        <li style={{ display: "list-item" }}>{v2vSheetData.achievements}</li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>
                </td>
              </tr>
            ) : (
              ""
            )}

            {/* <tr>
              <td style={{ width: "100%", verticalAlign: "top" }}>
                <div className="section">
                  <div className="section-header">INTEREST :</div>
                  {v2vSheetData.interest ? (
                    <ul
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        listStyleType: "circle",
                        paddingLeft: "30px",
                        rowGap: "8px",
                        columnGap: "30px"
                      }}
                    >
                      {v2vSheetData.interest.map((ins, index) => (
                        <li key={index} style={{ display: "list-item" }}>
                          {ins}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <Typography variant="body2">No Interests available</Typography>
                  )}
                </div>
              </td>
            </tr> */}
            {v2vSheetData.interest &&
              Array.isArray(v2vSheetData.interest) &&
              v2vSheetData.interest.filter((interest) => interest != null && interest !== "")
                .length > 0 && (
                <tr>
                  <td style={{ width: "100%", verticalAlign: "top" }}>
                    <div className="section">
                      <div className="section-header">INTEREST :</div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            {/* Left Column: First 5 Interests */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.interest
                                  .filter((interest) => interest != null && interest !== "")
                                  .slice(0, 5)
                                  .map((ins, index) => (
                                    <li key={index} style={{ display: "list-item" }}>
                                      {ins}
                                    </li>
                                  ))}
                              </ul>
                            </td>

                            {/* Right Column: Remaining Interests */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.interest
                                  .filter((interest) => interest != null && interest !== "")
                                  .slice(5)
                                  .map((ins, index) => (
                                    <li key={index + 5} style={{ display: "list-item" }}>
                                      {ins}
                                    </li>
                                  ))}
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}

            {/* {v2vSheetData.network !== null && (
              <tr>
                <td style={{ width: "100%", verticalAlign: "top" }}>
                  <div className="section">
                    <div className="section-header">
                      CURRENT LEADING ROLE IN BELOW ORGANIZATIONS
                    </div>
                    {Array.isArray(v2vSheetData.network) ? (
                      <ul
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          listStyleType: "circle",
                          paddingLeft: "30px",
                          rowGap: "8px",
                          columnGap: "30px"
                        }}
                      >
                        {v2vSheetData.network.map((net, index) => (
                          <li key={index} style={{ display: "list-item" }}>
                            {net}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <ul style={{ listStyleType: "circle", paddingLeft: "30px" }}>
                        <li style={{ fontSize: "16px" }}>{v2vSheetData.network}</li>
                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            )} */}
            {v2vSheetData.network &&
              Array.isArray(v2vSheetData.network) &&
              v2vSheetData.network.filter((net) => net != null && net !== "").length > 0 && (
                <tr>
                  <td style={{ width: "100%", verticalAlign: "top" }}>
                    <div className="section">
                      <div className="section-header">
                        CURRENT LEADING ROLE IN BELOW ORGANIZATIONS
                      </div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            {/* Left Column: First 5 items */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.network
                                  .filter((net) => net != null && net !== "")
                                  .slice(0, 5)
                                  .map((net, index) => (
                                    <li key={index} style={{ display: "list-item" }}>
                                      {net}
                                    </li>
                                  ))}
                              </ul>
                            </td>

                            {/* Right Column: Remaining items */}
                            <td
                              style={{
                                width: "50%",
                                verticalAlign: "top",
                                padding: "0",
                                paddingLeft: "10px"
                              }}
                            >
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.network
                                  .filter((net) => net != null && net !== "")
                                  .slice(5)
                                  .map((net, index) => (
                                    <li key={index + 5} style={{ display: "list-item" }}>
                                      {net}
                                    </li>
                                  ))}
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}

            {/* <tr>
              <td style={{ width: "100%", verticalAlign: "top" }}>
                <div className="section">
                  <div className="section-header">ASK & GIVE :</div>
                  <br />
                  <strong>ASK :</strong>
                  {v2vSheetData.myAsk ? (
                    <ul
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        listStyleType: "circle",
                        paddingLeft: "30px",
                        rowGap: "8px",
                        columnGap: "30px",
                        marginBottom: "20px"
                      }}
                    >
                      {v2vSheetData.myAsk.map((ask, index) => (
                        <li key={index} style={{ display: "list-item" }}>
                          {ask}
                        </li>
                      ))}
                    </ul>
                  ) : null}

                  <strong>GIVE :</strong>
                  {Array.isArray(v2vSheetData.myGive) ? (
                    <ul
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        listStyleType: "circle",
                        paddingLeft: "30px",
                        rowGap: "8px",
                        columnGap: "30px"
                      }}
                    >
                      {v2vSheetData.myGive.map((give, index) => (
                        <li key={index} style={{ display: "list-item" }}>
                          {give}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <ul style={{ listStyleType: "circle", paddingLeft: "30px" }}>
                      <li style={{ display: "list-item" }}>{v2vSheetData.myGive}</li>
                    </ul>
                  )}
                </div>
              </td>
            </tr> */}
            {(Array.isArray(v2vSheetData.myAsk) &&
              v2vSheetData.myAsk.filter((ask) => ask && ask !== "").length > 0) ||
            (Array.isArray(v2vSheetData.myGive) &&
              v2vSheetData.myGive.filter((give) => give && give !== "").length > 0) ? (
              <tr>
                <td style={{ width: "100%", verticalAlign: "top" }}>
                  <div className="section">
                    <div className="section-header">ASK & GIVE :</div>
                    <br />

                    {Array.isArray(v2vSheetData.myAsk) &&
                      v2vSheetData.myAsk.filter((ask) => ask && ask !== "").length > 0 && (
                        <>
                          <strong>ASK :</strong>
                          <table style={{ width: "100%", marginBottom: "20px" }}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "50%",
                                    verticalAlign: "top",
                                    paddingLeft: "10px"
                                  }}
                                >
                                  <ul
                                    style={{
                                      listStyleType: "circle",
                                      paddingLeft: "20px",
                                      margin: 0
                                    }}
                                  >
                                    {v2vSheetData.myAsk
                                      .filter((myAsk) => myAsk != null && myAsk !== "")
                                      .slice(0, 5)
                                      .map((ask, index) => (
                                        <li key={index} style={{ display: "list-item" }}>
                                          {ask}
                                        </li>
                                      ))}
                                  </ul>
                                </td>
                                <td
                                  style={{
                                    width: "50%",
                                    verticalAlign: "top",
                                    paddingLeft: "10px"
                                  }}
                                >
                                  <ul
                                    style={{
                                      listStyleType: "circle",
                                      paddingLeft: "20px",
                                      margin: 0
                                    }}
                                  >
                                    {v2vSheetData.myAsk
                                      .filter((myAsk) => myAsk != null && myAsk !== "")
                                      .slice(5)
                                      .map((ask, index) => (
                                        <li key={index + 5} style={{ display: "list-item" }}>
                                          {ask}
                                        </li>
                                      ))}
                                  </ul>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </>
                      )}

                    {Array.isArray(v2vSheetData.myGive) &&
                      v2vSheetData.myGive.filter((give) => give && give !== "").length > 0 && (
                        <>
                          <strong>GIVE :</strong>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "50%",
                                    verticalAlign: "top",
                                    paddingLeft: "10px"
                                  }}
                                >
                                  <ul
                                    style={{
                                      listStyleType: "circle",
                                      paddingLeft: "20px",
                                      margin: 0
                                    }}
                                  >
                                    {v2vSheetData.myGive
                                      .filter((myGive) => myGive != null && myGive !== "")
                                      .slice(0, 5)
                                      .map((give, index) => (
                                        <li key={index} style={{ display: "list-item" }}>
                                          {give}
                                        </li>
                                      ))}
                                  </ul>
                                </td>
                                <td
                                  style={{
                                    width: "50%",
                                    verticalAlign: "top",
                                    paddingLeft: "10px"
                                  }}
                                >
                                  <ul
                                    style={{
                                      listStyleType: "circle",
                                      paddingLeft: "20px",
                                      margin: 0
                                    }}
                                  >
                                    {v2vSheetData.myGive
                                      .filter((myGive) => myGive != null && myGive !== "")
                                      .slice(5)
                                      .map((give, index) => (
                                        <li key={index + 5} style={{ display: "list-item" }}>
                                          {give}
                                        </li>
                                      ))}
                                  </ul>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </>
                      )}
                  </div>
                </td>
              </tr>
            ) : (
              ""
            )}

            {/* <tr>
              <td style={{ width: "50%", verticalAlign: "top" }}>
                <div className="section">
                  <div className="section-header">HAPPY CLIENT LIST :</div>
                  {v2vSheetData.happyClient ? (
                    <ul
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        listStyleType: "circle",
                        paddingLeft: "30px",
                        rowGap: "8px",
                        columnGap: "30px"
                      }}
                    >
                      {v2vSheetData.happyClient.map((client, index) => (
                        <li key={index} style={{ display: "list-item" }}>
                          {client}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <Typography variant="body2">No Happy Client List available</Typography>
                  )}
                </div>
              </td>
            </tr> */}

            {Array.isArray(v2vSheetData.happyClient) &&
              v2vSheetData.happyClient.filter((client) => client && client !== "").length > 0 && (
                <tr>
                  <td style={{ width: "100%", verticalAlign: "top" }}>
                    <div className="section">
                      <div className="section-header">HAPPY CLIENT LIST :</div>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%", verticalAlign: "top", paddingLeft: "10px" }}>
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.happyClient
                                  .filter(
                                    (happyClient) => happyClient != null && happyClient !== ""
                                  )
                                  .slice(0, 5)
                                  .map((client, index) => (
                                    <li key={index} style={{ display: "list-item" }}>
                                      {client}
                                    </li>
                                  ))}
                              </ul>
                            </td>
                            <td style={{ width: "50%", verticalAlign: "top", paddingLeft: "10px" }}>
                              <ul
                                style={{ listStyleType: "circle", paddingLeft: "20px", margin: 0 }}
                              >
                                {v2vSheetData.happyClient
                                  .filter(
                                    (happyClient) => happyClient != null && happyClient !== ""
                                  )
                                  .slice(5)
                                  .filter(
                                    (happyClient) => happyClient != null && happyClient !== ""
                                  )
                                  .map((client, index) => (
                                    <li key={index + 5} style={{ display: "list-item" }}>
                                      {client}
                                    </li>
                                  ))}
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}

            {/* {v2vSheetData.otherBusiness !== null && (
              <tr>
                <td style={{ width: "50%", verticalAlign: "top" }}>
                  <div className="section">
                    <div className="section-header">OTHER BUSINESS :</div>
                    {Array.isArray(v2vSheetData.otherBusiness) ? (
                      <ul
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          listStyleType: "circle",
                          paddingLeft: "30px",
                          rowGap: "8px",
                          columnGap: "30px"
                        }}
                      >
                        {v2vSheetData.otherBusiness.map((other, index) => (
                          <li key={index} style={{ display: "list-item" }}>
                            {other}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <ul style={{ listStyleType: "circle", paddingLeft: "30px" }}>
                        <li style={{ display: "list-item" }}>{v2vSheetData.otherBusiness}</li>
                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            )} */}
            {v2vSheetData.otherBusiness !== null &&
              ((Array.isArray(v2vSheetData.otherBusiness) &&
                v2vSheetData.otherBusiness.filter((item) => item != null && item !== "").length >
                  0) ||
                (typeof v2vSheetData.otherBusiness === "string" &&
                  v2vSheetData.otherBusiness.trim() !== "")) && (
                <tr>
                  <td style={{ width: "100%", verticalAlign: "top" }}>
                    <div className="section">
                      <div className="section-header">OTHER BUSINESS :</div>
                      {Array.isArray(v2vSheetData.otherBusiness) &&
                      v2vSheetData.otherBusiness.length > 0 ? (
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td
                                style={{ width: "50%", verticalAlign: "top", paddingLeft: "10px" }}
                              >
                                <ul
                                  style={{
                                    listStyleType: "circle",
                                    paddingLeft: "20px",
                                    margin: 0
                                  }}
                                >
                                  {v2vSheetData.otherBusiness
                                    .filter(
                                      (otherBusiness) =>
                                        otherBusiness != null && otherBusiness !== ""
                                    )
                                    .slice(0, 5)
                                    .map((item, index) => (
                                      <li key={index} style={{ display: "list-item" }}>
                                        {item}
                                      </li>
                                    ))}
                                </ul>
                              </td>
                              <td
                                style={{ width: "50%", verticalAlign: "top", paddingLeft: "10px" }}
                              >
                                <ul
                                  style={{
                                    listStyleType: "circle",
                                    paddingLeft: "20px",
                                    margin: 0
                                  }}
                                >
                                  {v2vSheetData.otherBusiness
                                    .filter(
                                      (otherBusiness) =>
                                        otherBusiness != null && otherBusiness !== ""
                                    )
                                    .slice(5)
                                    .map((item, index) => (
                                      <li key={index + 5} style={{ display: "list-item" }}>
                                        {item}
                                      </li>
                                    ))}
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      ) : typeof v2vSheetData.otherBusiness === "string" &&
                        v2vSheetData.otherBusiness.trim() !== "" ? (
                        <ul style={{ listStyleType: "circle", paddingLeft: "30px" }}>
                          <li style={{ display: "list-item" }}>{v2vSheetData.otherBusiness}</li>
                        </ul>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                </tr>
              )}
          </table>

          {v2vSheetData.service && v2vSheetData.service.length > 0 && (
            <div className="section">
              <div style={{ textAlign: "center" }}>
                <div className="section-header">
                  IN LVB REGISTERED BUSINESS CATEGORY DETAILS:
                  <br /> {v2vSheetData.business_name}
                </div>
              </div>

              {/* Full width if only one table */}
              {fullWidth && fullWidth.length === 1 ? (
                <div style={{ width: "100%", padding: "0 15px" }}>{renderTable(fullWidth[0])}</div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%", verticalAlign: "top", padding: "0 15px" }}>
                        {leftColumn.map((service, idx) => renderTable(service))}
                      </td>
                      <td style={{ width: "50%", verticalAlign: "top", padding: "0 15px" }}>
                        {rightColumn.map((service, idx) => renderTable(service))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          )}
        </Card>
      </Container>
    </Page>
  );
}
